<template>
    <div class="body-matter-manage">
        <div class="item-type my-cursor"
             :class="matterType === typeItem ? 'img-type': ''"
             @click="setMatterType(typeItem)"
             v-for="typeItem in matterTypeItems">
            {{ typeItem }}
        </div>
        <div class="view-type">
            <div class="view-focus" :style="{transform: this.viewType === '列表视图'? 'translateX(0rem)': 'translateX(1rem)'}"></div>
            <div class="item-view-type my-cursor"
                 @click="setViewType(typeItem)"
                 v-for="typeItem in viewTypeItems">
                {{ typeItem }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MatterManage",
    data(){
        return {
            matterType: "日程清单", // 日程、待办
            matterTypeItems: [
                "日程清单",
                "待办清单"
            ],
            viewType: "列表视图",
            viewTypeItems: [
                "列表视图",
                "四象限"
            ],
        }
    },
    methods: {
        setMatterType: function(typeItem){
            if(this.matterType === typeItem){
                return
            }
            this.matterType = typeItem;
            this.$emit("submitMatterEvent");
        },
        setViewType: function(typeItem){
            if(this.viewType === typeItem){
                return
            }
            this.viewType = typeItem;
            this.$emit("submitViewEvent");
        }
    },
}
</script>

<style scoped>
div.body-matter-manage{
    width: 100%;
    height: 0.56rem;
    /*background: lightblue;*/
    box-sizing: border-box;
    padding: 0 0.5rem;
}
div.item-type{
    width: 0.9rem;
    height: 100%;
    display: inline-block;
    float: left;
    margin-right: 0.3rem;

    font-family: SourceHanSerifSC, SourceHanSerifSC, sans-serif;
    font-weight: bold;
    font-size: 0.2rem;
    color: #000000;
    line-height: 0.56rem;
    text-align: center;
}

div.img-type{
    background-image: url("../../../assets/images/List/img-type-line.png");
    background-position: center 0.34rem;
    background-repeat: no-repeat;
    background-size: 0.9rem 0.07rem;
}
div.view-type{
    width: 2rem;
    height: 0.36rem;
    margin-top: 0.1rem;
    float: right;
    border-radius: 0.18rem;
    box-sizing: border-box;
    border: 0.02rem solid #000000;
    display: flex;
}
div.item-view-type{
    flex: 1;
    font-family: SourceHanSerifSC, SourceHanSerifSC, sans-serif;
    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    text-align: center;
    line-height: 0.32rem;
    position: relative;
    z-index: 1;

}
div.view-focus{
    width: 1rem;
    height: 0.36rem;
    position: absolute;
    background: #FFEFB4;
    border: 0.02rem solid #000000;
    border-radius: 0.18rem;
    margin-top: -0.02rem;
    margin-left: -0.02rem;
    box-sizing: border-box;
    z-index: 0;
    transition: transform .5s ease-in-out;
    transform: translateX(0rem);
}


</style>